<template>
  <v-autocomplete
    v-model="address"
    :label="label"
    :items="locationFoundItems"
    :search-input.sync="locationSearchText"
    item-text="value"
    :loading="isLoading"
    clearable
    :readonly="isLocationActive"
    return-object
    autocomplete="off"
    allow-overflow
    :attach="'#attachGoogleAuto'"
  >
    <template v-slot:append-outer>
      <div id="attachGoogleAuto"></div>
      <v-slide-x-reverse-transition mode="out-in">
        <v-icon
          :key="`icon-${isLocationActive}`"
          :color="isLocationActive ? 'primary' : 'gray'"
          @click="isLocationActive = !isLocationActive"
          v-text="
            isLocationActive ? 'mdi-map-marker-radius' : 'mdi-map-marker-off'
          "
        />
      </v-slide-x-reverse-transition>
    </template>
  </v-autocomplete>
</template>

<script>
import {
  GetSuggestions,
  GetGeocoder,
  GetGeocoderInputs,
} from "@/utils/places-utils";

export default {
  name: "PlaceAutocompleteInput",
  props: {
    label: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    address: null,
    locationSearchText: null,
    locationEntries: [],
    isLoading: false,
    isLocationActive: false,
  }),
  computed: {
    locationFoundItems() {
      return this.locationEntries;
    },
  },
  watch: {
    locationSearchText: function (newVal) {
      const self = this;
      if (!this.isLocationActive) {
        // If less than 3 chars typed, do not search
        if (!newVal || newVal.length <= 3) return;
        self.isLoading = true;
        // Call the method from the previous section here
        GetSuggestions(newVal)
          .then(function (res) {
            if (res) {
              setTimeout(() => {
                self.locationEntries = res;
              }, 200);
            } else {
              self.locationEntries = [];
            }
          })
          .catch(function (error) {
            console.log(error);
            // error handling goes here
          });
        setTimeout(() => {
          self.isLoading = false;
        }, 500);
      }
    },
    isLocationActive: function (value) {
      this.locationEntries = [];
      if (value) {
        this.locatorButtonPressed();
      } else {
        this.address = null;
      }
    },
    address: function () {
      if (this.address) {
        this.getAddressComponents(this.address.value);
      } else {
        this.$emit("input", null);
      }
    },
  },

  methods: {
    locatorButtonPressed: function () {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.getStreetAddressFrom(
            position.coords.latitude,
            position.coords.longitude
          );
        },
        (error) => {
          console.log(error.message);
        }
      );
    },
    getStreetAddressFrom: async function (lat, lng) {
      const self = this;

      GetGeocoder(lat, lng)
        .then(function (res) {
          self.address = res;
          self.locationEntries.push(res);
        })
        .catch(function (error) {
          console.log(error);
          // error handling goes here
        });
    },
    getAddressComponents: async function (prettyAddress) {
      const self = this;
      GetGeocoderInputs(prettyAddress)
        .then(function (res) {
          self.$emit("input", res);
        })
        .catch(function (error) {
          console.log(error);
          // error handling goes here
        });
    },
  },
};
</script>
